export default __webpack_public_path__ + "assets/images/d0e1311c5719c74a03d1819a00ea22af.jpg";